import React, { useEffect } from 'react';
import { BANNER_URL } from './data';
const SITE_URL = 'https://gbstudiony.com';
const PAGE_TITLE = 'Ginger Briones Studio | Luxury Hair Salon · Queens, New York';
const PAGE_DESCRIPTION = "Queens' premier luxury hair salon. Specializing in balayage, highlights, color and wellness treatments. Located at 96-02 37th Ave, Corona, NY. Book now: (347) 888-6047";
const SOCIAL_DESCRIPTION = "Queens' premier luxury hair salon. Balayage, highlights, color and wellness. 96-02 37th Ave, Corona, NY. Call (347) 242-2967";
const GOOGLE_SITE_VERIFICATION = '';
interface HeadAttribute {
  name: string;
  value: string;
}
export function SeoHead() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    upsertMeta('meta[charset]', [{
      name: 'charset',
      value: 'UTF-8'
    }]);
    upsertMeta('meta[name="viewport"]', [{
      name: 'name',
      value: 'viewport'
    }, {
      name: 'content',
      value: 'width=device-width, initial-scale=1.0'
    }]);
    upsertMeta('meta[name="title"]', [{
      name: 'name',
      value: 'title'
    }, {
      name: 'content',
      value: PAGE_TITLE
    }]);
    upsertMeta('meta[name="description"]', [{
      name: 'name',
      value: 'description'
    }, {
      name: 'content',
      value: PAGE_DESCRIPTION
    }]);
    upsertMeta('meta[name="keywords"]', [{
      name: 'name',
      value: 'keywords'
    }, {
      name: 'content',
      value: 'hair salon Queens NY, balayage Queens, highlights Corona NY, hair color Queens New York, luxury hair salon Queens, Ginger Briones Studio, hair salon Corona NY, best hair salon Queens, balayage near me Queens, hair highlights Queens NY, keratin treatment Queens, hair wellness Queens NY'
    }]);
    upsertMeta('meta[name="author"]', [{
      name: 'name',
      value: 'author'
    }, {
      name: 'content',
      value: 'Ginger Briones Studio'
    }]);
    upsertMeta('meta[name="robots"]', [{
      name: 'name',
      value: 'robots'
    }, {
      name: 'content',
      value: 'index, follow'
    }]);
    upsertMeta('meta[name="language"]', [{
      name: 'name',
      value: 'language'
    }, {
      name: 'content',
      value: 'English'
    }]);
    upsertMeta('meta[name="geo.region"]', [{
      name: 'name',
      value: 'geo.region'
    }, {
      name: 'content',
      value: 'US-NY'
    }]);
    upsertMeta('meta[name="geo.placename"]', [{
      name: 'name',
      value: 'geo.placename'
    }, {
      name: 'content',
      value: 'Corona, Queens, New York'
    }]);
    upsertMeta('meta[name="geo.position"]', [{
      name: 'name',
      value: 'geo.position'
    }, {
      name: 'content',
      value: '40.7282;-73.8649'
    }]);
    upsertMeta('meta[property="og:type"]', [{
      name: 'property',
      value: 'og:type'
    }, {
      name: 'content',
      value: 'website'
    }]);
    upsertMeta('meta[property="og:url"]', [{
      name: 'property',
      value: 'og:url'
    }, {
      name: 'content',
      value: SITE_URL
    }]);
    upsertMeta('meta[property="og:title"]', [{
      name: 'property',
      value: 'og:title'
    }, {
      name: 'content',
      value: PAGE_TITLE
    }]);
    upsertMeta('meta[property="og:description"]', [{
      name: 'property',
      value: 'og:description'
    }, {
      name: 'content',
      value: SOCIAL_DESCRIPTION
    }]);
    upsertMeta('meta[property="og:image"]', [{
      name: 'property',
      value: 'og:image'
    }, {
      name: 'content',
      value: BANNER_URL
    }]);
    upsertMeta('meta[property="og:site_name"]', [{
      name: 'property',
      value: 'og:site_name'
    }, {
      name: 'content',
      value: 'Ginger Briones Studio'
    }]);
    upsertMeta('meta[property="og:locale"]', [{
      name: 'property',
      value: 'og:locale'
    }, {
      name: 'content',
      value: 'en_US'
    }]);
    upsertMeta('meta[name="twitter:card"]', [{
      name: 'name',
      value: 'twitter:card'
    }, {
      name: 'content',
      value: 'summary_large_image'
    }]);
    upsertMeta('meta[name="twitter:title"]', [{
      name: 'name',
      value: 'twitter:title'
    }, {
      name: 'content',
      value: 'Ginger Briones Studio | Queens, New York'
    }]);
    upsertMeta('meta[name="twitter:description"]', [{
      name: 'name',
      value: 'twitter:description'
    }, {
      name: 'content',
      value: 'Luxury hair salon in Queens NY. Balayage, highlights, color and wellness.'
    }]);
    upsertMeta('meta[name="twitter:image"]', [{
      name: 'name',
      value: 'twitter:image'
    }, {
      name: 'content',
      value: BANNER_URL
    }]);
    upsertMeta('meta[name="google-site-verification"]', [{
      name: 'name',
      value: 'google-site-verification'
    }, {
      name: 'content',
      value: GOOGLE_SITE_VERIFICATION
    }]);
    upsertCanonical();
    upsertStructuredData();
  }, []);
  return null;
}
function upsertMeta(selector: string, attributes: HeadAttribute[]) {
  const meta = document.head.querySelector<HTMLMetaElement>(selector) ?? document.createElement('meta');
  attributes.forEach(({
    name,
    value
  }) => meta.setAttribute(name, value));
  if (!meta.parentNode) {
    document.head.appendChild(meta);
  }
}
function upsertCanonical() {
  const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]') ?? document.createElement('link');
  canonical.setAttribute('rel', 'canonical');
  canonical.setAttribute('href', SITE_URL);
  if (!canonical.parentNode) {
    document.head.appendChild(canonical);
  }
}
function upsertStructuredData() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HairSalon',
    name: 'Ginger Briones Studio',
    image: BANNER_URL,
    description: 'Queens premier luxury hair salon specializing in balayage, highlights, color and wellness',
    url: SITE_URL,
    telephone: '(347) 242-2967',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '96-02 37th Ave',
      addressLocality: 'Corona',
      addressRegion: 'NY',
      postalCode: '11368',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 40.7282,
      longitude: -73.8649
    },
    openingHoursSpecification: [{
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '09:30',
      closes: '20:00'
    }],
    sameAs: ['https://www.instagram.com/gbstudiony', 'https://www.facebook.com/gbstudiony'],
    priceRange: '$$',
    servesCuisine: 'Hair & Beauty Services'
  };
  const scriptId = 'ginger-briones-studio-local-business-schema';
  const script = document.getElementById(scriptId) ?? document.createElement('script');
  script.id = scriptId;
  script.setAttribute('type', 'application/ld+json');
  script.textContent = JSON.stringify(schema);
  if (!script.parentNode) {
    document.head.appendChild(script);
  }
}